import makeStyles from "@mui/styles/makeStyles";

export const useAutocompleteMediumStyles = makeStyles(() => ({
  listbox: {
    fontSize: 14,
  },
  input: {
    "&[aria-disabled=true]": {
      pointerEvents: "none",
    },
  },
}));

export const useAutocompleteSmallStyles = makeStyles(() => ({
  listbox: {
    fontSize: 12,
  },
  input: {
    "&[aria-disabled=true]": {
      pointerEvents: "none",
    },
  },
}));
